import { useRef } from 'react';
import constate from 'constate';

const useClipThumbPrevProvider = () => {
  const hoveredClip = useRef<CellClip>(null);

  const resetHoveredClip = () => {
    hoveredClip.current = null;
  };

  const setHoveredClip = (cellClip: CellClip) => {
    hoveredClip.current = cellClip;
  };

  return { hoveredClip, resetHoveredClip, setHoveredClip };
};

export const [ClipThumbPrevProvider, useClipThumbPrevContext] = constate(useClipThumbPrevProvider, (state) => state);
